// export const userTabs = [
//   {
//     name: "Details",
//     child: [],
//     parentid: "myTabContent",
//     elementid: "section-1716787421420",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
//   {
//     name: "New",
//     child: [],
//     parentid: "myTabContent",
//     elementid: "section-1716792504600",
//     description: "",
//     elementtype: "section",
//     "section-type": "form",
//     linkedentitytype: -1,
//   },
// ];

export const userTabs = [
  { label: "Details", value: "details" },
  { label: "User PSP Mapping", value: "psp_mapping" },
  { label: "User AG Mapping", value: "ag_mapping" },
  // { label: "User AGSA Mapping", value: "agsa_mapping" },
];

